import { BModal } from 'bootstrap-vue'
import consultations from '@/store/mods/consultations/consultations'

export default {
    name: 'avis-medical',
    components: { BModal },
    props: { consultation_api: { type: Object, default: null }, consultation: { type: Object, required: true }, patient: { type: Object, required: true } },
    data() {
        return { visible: false, loading: false, sending: false, error: '', token: '', context_id: null,
            specialites: [], confreres: [], avis: [], type_consultation_id: null, doctor_id: null,
            priorite: 'normale', question: '' }
    },
    computed: {
        modifiable() {
            return Number(this.consultation.is_end) === 0 ||
                !!(this.consultation.complement && this.consultation.complement.jusqu_au)
        },
        service() { return this.consultation_api || consultations },
        confreresFiltres() {
            return this.confreres.filter(item => !this.type_consultation_id ||
                (item.specialites || []).map(Number).includes(Number(this.type_consultation_id)))
        },
        avisEnAttente() { return this.avis.filter(item => !item.reponse).length }
    },
    methods: {
        async ouvrir() {
            if (Number(this.consultation.is_start) !== 1 || !this.modifiable ||
                Number(this.consultation.patient_id) !== Number(this.patient.id)) return
            this.context_id = Number(this.consultation.id)
            this.visible = true
            this.error = ''
            this.question = ''
            this.type_consultation_id = null
            this.doctor_id = null
            this.priorite = 'normale'
            this.loading = true
            try {
                const access = await this.service.getTableauMedecinAccess()
                if (!access || access.success !== true || !access.data || !access.data.access_token) throw new Error('Autorisation indisponible.')
                if (this._isDestroyed || !this.visible || Number(this.consultation.id) !== this.context_id) return
                this.token = access.data.access_token
                const [catalogue, historique] = await Promise.all([
                    this.service.getReferenceCatalogue({ access_token: this.token }),
                    this.service.getAvisMedicalConsultation(this.context_id, this.token)
                ])
                if (this._isDestroyed || !this.visible || Number(this.consultation.id) !== this.context_id) return
                this.specialites = Array.isArray(catalogue.specialites) ? catalogue.specialites : []
                this.confreres = Array.isArray(catalogue.confreres) ? catalogue.confreres : []
                this.avis = Array.isArray(historique.data) ? historique.data : []
                this.$emit('avis-compte', this.avisEnAttente)
            } catch (error) {
                if (!this._isDestroyed) this.error = error && error.message ? error.message : 'Impossible de charger les avis.'
            } finally {
                if (!this._isDestroyed) this.loading = false
            }
        },
        fermer() { if (!this.sending) this.visible = false },
        beforeHide(event) { if (this.sending) event.preventDefault() },
        async envoyer() {
            if (this.sending || !this.visible) return
            if (!(Number(this.type_consultation_id) > 0) || !this.question.trim()) {
                this.error = 'Choisissez une spécialité et renseignez la question clinique.'
                return
            }
            if (!['normale', 'urgente', 'immediate'].includes(this.priorite) || this.question.trim().length > 2000) {
                this.error = 'Vérifiez la priorité et limitez la question à 2 000 caractères.'
                return
            }
            if (!this.token || Number(this.consultation.id) !== this.context_id || !this.modifiable) {
                this.error = 'Le contexte de la consultation a changé. Rouvrez la fenêtre.'
                return
            }
            const payload = { type_consultation_id: Number(this.type_consultation_id), doctor_id: Number(this.doctor_id) > 0 ? Number(this.doctor_id) : null,
                priorite: this.priorite, question: this.question.trim() }
            this.sending = true
            this.error = ''
            try {
                await this.service.demanderAvisMedical(this.context_id, payload, this.token)
                if (this._isDestroyed) return
                this.$emit('avis-demande')
                this.visible = false
            } catch (error) {
                if (!this._isDestroyed) this.error = error && error.response && error.response.data && error.response.data.message ||
                    'La demande d’avis n’a pas été enregistrée.'
            } finally {
                if (!this._isDestroyed) this.sending = false
            }
        }
    }
}
